<template>
    <span class="cursor-pointer mx-2 feather-icon">
    <feather-icon icon="CheckSquareIcon" v-on:click="todoPrompt = true" />
    <vs-popup :active.sync="todoPrompt" :title='$t("todo.title")' class="full-width-popup" >

      <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden bg-white">
        <vs-sidebar class="items-no-padding" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isTodoSidebarActive">
          <h4 class="text-primary px-6 py-5 border-b border-solid d-theme-border-grey-light">{{$t("todo.h1")}}</h4>
          <component :is="scrollbarTag" class="todo-scroll-area" :settings="settings" :key="$vs.rtl">
            <!-- Added listener for closeSidebar to hide on mobile when a filter is clicked -->
            <todo-filters v-on:filter="onFilterClick" @closeSidebar="closeSidebarOnMobile"></todo-filters>
          </component>
        </vs-sidebar>
        
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content transition-all duration-300">

          <!-- SEARCH HEADER - Fixed Menu Icon Click -->
          <div class="flex d-theme-dark-bg items-center border-b border-solid d-theme-border-grey-light bg-gray-50 p-2">
            <!-- FIXED: Changed toggle function to actually toggle, added hover styling -->
            <div class="p-2 ml-2 mr-2 rounded hover:bg-gray-200 cursor-pointer transition-colors duration-200" @click.stop="toggleTodoSidebar()">
              <feather-icon class="md:inline-flex text-gray-600 hover:text-primary" icon="MenuIcon" />
            </div>
            
            <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" :placeholder='$t("todo.lbl2")' v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full bg-transparent" />
          </div>

          <!-- TODO LIST -->
          <component :is="scrollbarTag" class="todo-content-scroll-area p-4 bg-gray-50/50" :settings="settings" ref="taskListPS" :key="$vs.rtl">
            <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
              <li
                class="cursor-pointer todo_todo-item"
                v-for="(task, index) in taskList"
                :key="String(currFilter) + String(task.id)"
                :style="[{transitionDelay: (index * 0.05) + 's'}]">

                <todo-task 
                  vs-trigger-click 
                  :taskId="task.id" 
                  :compId="task.competencyId" 
                  :filter="filter" 
                  :searchQuery="searchQuery"
                  @showDisplayPrompt="showDisplayPrompt($event)" 
                  :key="String(task.competencyId)" 
                  v-on:todoPrompt=vs-trigger-click 
                />
              </li>
            </transition-group>
          </component>

        </div>
        <todo-edit :displayPrompt="displayPrompt" :taskId="taskIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></todo-edit>
      </div>
    </vs-popup>
    </span>
</template>

<script>
  import moduleTodo          from '@/store/add-skill/moduleAddSkill.js'
  import TodoAddNew          from './TodoAddNew.vue'
  import TodoTask            from './TodoTask.vue'
  import TodoFilters         from './TodoFilters.vue'
  import TodoEdit            from './TodoEdit.vue'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    props: {
      userId: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        currFilter           : '',
        clickNotClose        : true,
        displayPrompt        : false,
        taskIdToEdit         : 0,
        isTodoSidebarActive  : true,
        settings : {
          maxScrollbarLength : 60,
          wheelSpeed         : 0.30
        },
        taskList             : [],
        filter               : 'all',
        todoPrompt           : false,
        searchQuery          : '' 
      }
    },
    watch: {
      windowWidth () {
        this.setSidebarWidth()
      }
    },
    computed: {
      scrollbarTag () { return this.$store.getters.scrollbarTag              },
      windowWidth ()  { return this.$store.state.windowWidth                 }
    },
    methods: {
      onFilterClick(value){
        this.filter = value;
      },
      showDisplayPrompt (itemId) {
        this.taskIdToEdit  = itemId
        this.displayPrompt = true
      },
      hidePrompt () {
        this.displayPrompt = false
      },
      setSidebarWidth () {
        if (this.windowWidth < 900) {
          this.isTodoSidebarActive = this.clickNotClose = false
        } else {
          this.isTodoSidebarActive = this.clickNotClose = true
        }
      },
      // FIXED: Actually toggles the menu and handles the layout spacer on desktop
      toggleTodoSidebar (value = null) {
        if (value !== null) {
          this.isTodoSidebarActive = value;
        } else {
          this.isTodoSidebarActive = !this.isTodoSidebarActive;
        }
        
        // If on desktop, also toggle the spacer so the content area expands/collapses properly
        if (this.windowWidth >= 900) {
          this.clickNotClose = this.isTodoSidebarActive;
        }
      },
      // Closes sidebar when a filter is clicked on mobile devices
      closeSidebarOnMobile () {
        if (this.windowWidth < 900) {
          this.toggleTodoSidebar(false);
        }
      }
    },
    components: {
      TodoAddNew,
      TodoTask,
      TodoFilters,
      TodoEdit,
      VuePerfectScrollbar
    },
    created () {
      this.$store.registerModule('todo', moduleTodo)
      this.setSidebarWidth()
      const userId = this.$store.state.AppActiveUser.usersId;
      this.$store.dispatch('addSkill/findCompetency', {query:{users_id:this.userId,progress_status:'in_progress'}}).
      then(res => {
        this.taskList = res.data.sort((a, b) => b.id - a.id);
      })
    },
    beforeDestroy () {
      this.$store.unregisterModule('todo')
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/todo.scss";
  
  /* Kill any shadows on the inner app wrapper */
  #todo-app {
    box-shadow: none !important;
  }
  
  /* Make sure the list items themselves aren't projecting shadows */
  .todo_todo-item {
    box-shadow: none !important;
  }
  
  /* Centers Popup */
  .full-width-popup .vs-popup {
    width: 90% !important;
    max-width: 1100px;
    border-radius: 12px;
  }
  
  .no-scroll-content {
    transition: margin-left 0.3s ease;
  }
  
  .vs-input-no-border input:focus {
    background: transparent !important;
  }
</style>